import { AgentBroker } from '../domain/agentBroker.model'
import AgentRepository from '../repository/agent.repository'
import { getUserRoles } from './storage.service'

export default {
  getAgentBroker: async function(agentNumber: string) {
    try {
      const agent = await AgentRepository.getAgentBroker(agentNumber)
      return agent.data
    } catch (error) {
      console.log(error)
    }
  },

  saveAgent: async function(agent: AgentBroker) {
    return AgentRepository.putAgent(agent)
  },

  isAgent: function() {
    const roles = getUserRoles()
    if (!roles || roles.length < 1) {
      return false
    }
    const isAgentLogged = roles.includes(process.env.REACT_APP_ROLE_AGENT)
    return isAgentLogged
  },

  isBroker: function() {
    const roles = getUserRoles()
    if (!roles || roles.length < 1) {
      return false
    }
    const isAgentLogged = roles.includes(process.env.REACT_APP_ROLE_BROKER)
    return isAgentLogged
  },

  isAgentOrBroker: function() {
    return this.isAgent() || this.isBroker()
  },
}
